import React from "react";
import { Spinner } from "@phosphor-icons/react";

/**
 * Brand-bridge overlay shown for ~800ms before redirecting the user
 * to auth.emergentagent.com (Google OAuth). Reinforces the Pronto brand
 * during the handoff, since the upstream OAuth page is Emergent-branded.
 */
export default function GoogleHandoff({ visible }) {
  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-[80] bg-[#FAFAF7] flex flex-col items-center justify-center"
      style={{
        paddingTop: "max(env(safe-area-inset-top), 24px)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="google-handoff"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-7 px-6 text-center">
        <img
          src="/logo/full-with-tagline.png?v=2"
          alt="Pronto"
          className="h-12 w-auto select-none"
          draggable="false"
        />
        <div className="flex items-center gap-2.5 text-[#7C8B6E]">
          <Spinner size={18} className="animate-spin" weight="bold" />
          <span className="text-[10px] uppercase tracking-[0.22em] font-semibold">
            Apertura accesso sicuro
          </span>
        </div>
        <p className="font-editorial text-2xl lg:text-3xl text-[#1C1C1A] max-w-md leading-tight tracking-tight">
          Ti stiamo portando su <span className="italic-accent text-[#7C8B6E]">Google</span>.
        </p>
        <p className="text-xs text-[#6B6A65] max-w-xs">
          Useremo solo il tuo nome, la tua email e la foto profilo. Non chiediamo accessi alla casella di posta.
        </p>
      </div>
    </div>
  );
}
